import { Config } from "@/settings/Config";

export class DebugLogger {
  private static enabled = new Config().debug;

  public static log(...args: any[]) {
    if (DebugLogger.enabled) {
      console.log.apply(this, args);
    }
  }

  public static error(...args: any[]) {
    if (DebugLogger.enabled) {
      console.error.apply(this, args);
    }
  }

  public static time(label: string) {
    if (DebugLogger.enabled) {
      console.time(label);
    }
  }

  public static timeEnd(label: string) {
    if (DebugLogger.enabled) {
      console.timeEnd(label);
    }
  }
}
